import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatVehicleName } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const FeatureUsageMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Group'), value: row.vehicle_group },
		{ label: t('Live_Video_(min)'), value: row.live_video_min },
		{ label: t('Event_Clips'), value: row.event_clips_number },
		{ label: t('Custom_Clips'), value: row.custom_clips_number },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default FeatureUsageMobileCard;
